import React from 'react';
import classNames from 'classnames';
import getGlyph from './glyphs';
import { TYPES } from './constants';

function Icon({
  glyph,
  type = TYPES.default,
  size = 24,
  strokeWidth = 1.3,
  insideText = false,
  withScaleFactor = false,
  ...otherProps
}) {
  const classes = classNames('ws-ui-icon', `ws-ui-icon--${type}`, {
    'ws-ui-icon--inside-text': insideText,
    'ws-ui-icon--with-scale-factor': withScaleFactor,
  });
  const Glyph = getGlyph(glyph);

  if (Glyph) {
    return (
      <span className={classes}>
        <Glyph {...otherProps} size={size} strokeWidth={strokeWidth} />
      </span>
    );
  }

  return null;
}

export default Icon;
